import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "input-controls" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "right" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_Prompts = _resolveComponent("Prompts")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_InputRecorder = _resolveComponent("InputRecorder")
  const _component_SendButton = _resolveComponent("SendButton")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "left",
      disabled: $props.recording || $props.generating
    }, [
      ($props.uploadsEnabled)
        ? (_openBlock(), _createBlock(_component_Tooltip, {
            key: 0,
            text: "Attach file"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Icon, {
                class: _normalizeClass(["pointer", {disabled: !$props.canUpload}]),
                stroke: "#414651",
                width: "2rem",
                height: "2rem",
                icon: "attachment-02",
                "stroke-width": "1",
                hoverable: "",
                onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.$emit('upload')), ["stop"]))
              }, null, 8 /* PROPS */, ["class"])
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_Prompts, {
        onSelectPrompt: _cache[1] || (_cache[1] = $event => (_ctx.$emit('prompt', $event)))
      }),
      _createVNode(_component_InputSwitch)
    ], 8 /* PROPS */, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_InputRecorder, {
        class: "recorder",
        disabled: $props.generating,
        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
        onTranscribed: _cache[3] || (_cache[3] = $event => (_ctx.$emit('transcribed', $event)))
      }, null, 8 /* PROPS */, ["disabled"]),
      _createVNode(_component_SendButton, {
        class: "send",
        generating: $props.generating,
        "can-push": $props.canPush,
        onPush: _cache[4] || (_cache[4] = $event => (_ctx.$emit('push', $event))),
        onStop: _cache[5] || (_cache[5] = $event => (_ctx.$emit('stop')))
      }, null, 8 /* PROPS */, ["generating", "can-push"])
    ])
  ]))
}